import { watch } from 'vue';

import Locale from '../models/utilities/locale.model';
import BootstrapModel from '../models/utilities/bootstrap.model';

import { useStore } from '../composables/store.composable';

import SeamlessStoreService from './seamless-store.service';

import { useRouting } from '../composables/routing.composable';

export default class BootstrapService {
  static async mountComponent(
    { countryCode, language, isStandalone }: BootstrapModel,
    useDefaultBootstrap = false
  ): Promise<Locale | undefined> {
    const { clearQueryParam, queryParams } = useRouting();
    const { commit } = useStore();
    let countryLang = {
      countryCode,
      language,
    };
    if (isStandalone) {
      const localCountryCode = window.localStorage.getItem('otb-country');
      const localLanguage = window.localStorage.getItem('otb-lang');
      if (localCountryCode && localLanguage) {
        countryLang = {
          countryCode: localCountryCode,
          language: localLanguage,
        };
      }
      watch(
        () => [queryParams?.value.country, queryParams?.value.lang],
        () => {
          let countryLang;
          if (queryParams?.value.country && queryParams?.value.lang) {
            countryLang = {
              countryCode: queryParams.value.country,
              language: queryParams.value.lang,
            };
            window.localStorage.setItem('otb-country', countryLang.countryCode);
            window.localStorage.setItem('otb-lang', countryLang.language);

            if (clearQueryParam) {
              clearQueryParam('country');
              clearQueryParam('lang');
            }

            BootstrapService.updateContext(countryLang);
          }
        }
      );
      commit('isStandalone', true);
    }

    if (useDefaultBootstrap) {
      await BootstrapService.bootstrap(countryLang);
    }

    return countryLang;
  }

  static async bootstrap(locale: Locale): Promise<void> {
    const { dispatch } = useStore();
    await SeamlessStoreService.initSeamlessStore(locale);
    await dispatch('fetchConfigurations');
  }

  static async updateContext(locale: Locale): Promise<void> {
    const { commit, dispatch } = useStore();
    commit('locale', locale);
    await dispatch('fetchConfigurations');
    dispatch('getSpecificModel');
  }
}
